module.exports = __webpack_public_path__ + "img/empty_woman_walking.3f100032.jpg";